





















import type { PropType } from '@vue/composition-api';
import { watch, ref, defineComponent } from '@vue/composition-api';
import type { EditorBlock } from '@getaccept/editor-lib';
import NameInput from '@getaccept/dsr-shared/src/components/NameInput.vue';
import SectionList from './SectionList.vue';

export default defineComponent({
  name: 'BlockListItem',
  components: {
    SectionList,
    NameInput,
  },
  props: {
    block: {
      type: Object as PropType<EditorBlock>,
      required: true,
    },
    isCurrentBlock: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const sectionsOpen = ref(false);
    const nameInputValue = ref(props.block.content.displayName || 'Untitled page');

    watch(
      () => props.isCurrentBlock,
      () => {
        if (props.isCurrentBlock) {
          sectionsOpen.value = true;
        }
      },
      { immediate: true }
    );

    const toggleSections = () => {
      sectionsOpen.value = !sectionsOpen.value;
    };

    return {
      sectionsOpen,
      toggleSections,
      nameInputValue,
    };
  },
});
